/*
* Report common utilities & components
*/

import * as React from 'react';
import { FormattedNumber } from 'react-intl';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';

// FORMATTERS
export const BidLetterContractItem = ({ numeral = '', indent = false, numeralColXs = 1, childrenColXs = 11, children, ...rest }) => {
    return (
        <Row className="pdf-order-bid-contract-item-row-wrapper">
            <Col xs={numeralColXs} className="pdf-order-bid-contract-item-numeral">
                {numeral}
            </Col>
            <Col xs={childrenColXs}>
                <div className={`pdf-order-bid-contract-item-children-wrapper ${indent ? 'pdf-order-bid-contract-item-children-wrapper-indent' : ''}`}>
                    {children}
                </div>
            </Col>
        </Row>
    );
};

export const BidLetterFooter = ({pageNumText, associationName, assocColXs = 9, initialsColXs = 3, initialsText = 'Initials: _____', ...rest}) => {
    return (
        <div className="pdf-order-bid-contract-footer-wrapper">
            <BidLetterContractItem numeral="">
                <Row>
                    <Col xs={assocColXs}>
                        <span className="pdf-order-bid-contract-assoc pdf-order-bid-contract-footer-left">{pageNumText}, {associationName}</span>
                    </Col>
                    <Col xs={initialsColXs} className="text-right">
                        <span className="pdf-order-bid-contract-assoc text-right pdf-order-bid-contract-footer-right">{initialsText}</span>
                    </Col>
                </Row>
            </BidLetterContractItem>
    </div>

    );
};

export const CurrencyNAZeroValue = ({ value, decimals = 2, hidden = false, zeroValueText = 'N/A', ...rest }) => {
    if (hidden) { return <span />; }

    if (!value) {
        return (
            <span>{zeroValueText}</span>
        );
    } else {
        return (
            <FormattedNumber value={value} style="currency" currency="USD" minimumFractionDigits={decimals} maximumFractionDigits={decimals} />
        );
    }
};

// PAGE CONTAINERS
export const ReportPage = ({ wrapperClassName = '', className = '', reportData, ...rest }) => {
    const { currentOrderChart } = reportData;

    return (
        <div className={`pdf-order-bid-letter-page-wrapper ${wrapperClassName}`}>
            <div className={`pdf-order-bid-letter-page ${className}`}>{rest.children}</div>
        </div>
    );
};

export const ReportEnvelopePage = ({ wrapperClassName = '', className = '', reportData, ...rest }) => {
    return (
        <div className={`pdf-order-bid-envelope-page-wrapper ${wrapperClassName}`}>
            <div className={`pdf-order-bid-envelope-page ${className}`}>{rest.children}</div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/order/bid-letter/report-components.tsx